export default __webpack_public_path__ + "static/media/launchpad1.22bfeaf5.svg";